import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { AcademyService } from "../report-services/academy.service";
import { GradeLevelService } from "../report-services/grade-level.service";
import { GroupService } from "../report-services/group.service";
import { HomeroomService } from "../report-services/homeroom.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { ReportService } from "../report.service";
import { UserService } from "../../../shared";

@Component({
	selector: "app-temp-id-cards-printed",
	templateUrl: "./temp-id-cards-printed.component.html",
	styleUrls: ["./temp-id-cards-printed.component.css"],
})
export class TempIdCardsPrintedComponent implements OnInit {
	constructor(
		private userService: UserService,
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private groupService: GroupService,
		private homeroomService: HomeroomService,
		private academyService: AcademyService,
		private gradelevelService: GradeLevelService,
		private schoolService: SchoolService,
		private dialogService: DialogService
	) {}

	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		GradeLevelID: 0,
		AcademyID: 0,
		HomeroomID: 0,
		GroupID: 0,
		ActiveOptionID: 1,
		SortBy: "FirstName",
		SortDirection: "ASC",
		ImageLogo: "",
	};

	//Insert Custom Lists Here
	schoolList: any = [];
	GradeLevelList: any = [];
	AcademyList: any = [];
	HomeroomList: any = [];
	GroupList: any = [];
	ImageLogoList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ActiveOptionList: any = [
		{
			ID: -1,
			Desc: "Any",
		},
		{
			ID: 1,
			Desc: "Active",
		},
		{
			ID: 0,
			Desc: "Inactive",
		},
	];

	SortByList: any = [
		{
			ID: "FirstName",
			Desc: "First Name",
		},
		{
			ID: "LastName",
			Desc: "Last Name",
		},
		{
			ID: "StudentID",
			Desc: "Student ID",
		},
		{
			ID: "GradeLevel",
			Desc: "Grade Level",
		},
		{
			ID: "Homeroom",
			Desc: "Homeroom",
		},
		{
			ID: "WTD",
			Desc: "Week to Date Temp IDs Printed",
		},
		{
			ID: "MTD",
			Desc: "Month to Date Temp IDs Printed",
		},
		{
			ID: "3MTD",
			Desc: "Past 3 Months to Date Temp IDs Printed",
		},
		{
			ID: "YTD",
			Desc: "Year to Date Temp IDs Printed",
		},
		{
			ID: "IDStatus",
			Desc: "ID Statuses when printing Temp IDs",
		},
	];

	SortDirectionList: any = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 472;

	subscription: any;

	ngOnInit() {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadGradeLevelList();
		this.loadAcademyList();
		this.loadHomeroomList();
		this.loadGroupList();
		this.loadLogolist();
	}

	private loadGradeLevelList() {
		this.report.GradeLevelID = 0;
		var result = this.gradelevelService.loadGradeLevelList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GradeLevelList = response;

				this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
			},
			(error) => {}
		);
	}

	private loadAcademyList() {
		this.report.AcademyID = 0;
		var result = this.academyService.loadAcademyList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.AcademyList = response;

				this.report.AcademyID = this.AcademyList[0].AcademyId;
			},
			(error) => {}
		);
	}

	private loadHomeroomList() {
		this.report.HomeroomID = 0;
		var result = this.homeroomService.loadHomeroomList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.HomeroomList = response;

				this.report.HomeroomID = this.HomeroomList[0].HomeroomId;
			},
			(error) => {}
		);
	}

	private loadGroupList() {
		this.report.GroupID = 0;
		var result = this.groupService.loadGroupList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GroupList = response;

				this.report.GroupID = this.GroupList[0].GroupID;
			},
			(error) => {}
		);
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		if (!this.report.SchoolID) {
			this.errorMessage = "Select the School";
			return;
		}

		// if (!this.report.GradeLevelID) {
		// 	this.errorMessage = "Select the GradeLevel"
		// 	return;
		// }

		// if (!this.report.AcademyID) {
		// 	this.errorMessage = "Select the Academy"
		// 	return;
		// }

		// if (!this.report.HomeroomID) {
		// 	this.errorMessage = "Select the Homeroom"
		// 	return;
		// }

		// if (!this.report.GroupID) {
		// 	this.errorMessage = "Select the Group"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var result = this.reportService.Print(this.ReportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: UserID
		strParam += this.user.userID + "|UserID";

		//Parameter 2: GradeLevelID
		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";

		//Parameter 3: AcademyID
		strParam += "," + this.report.AcademyID + "|AcademyID";

		//Parameter 4: HomeroomID
		strParam += "," + this.report.HomeroomID + "|HomeroomID";

		//Parameter 5: GroupID
		strParam += "," + this.report.GroupID + "|GroupID";

		//Parameter 6: Active
		strParam += "," + this.report.ActiveOptionID + "|Active";

		//Parameter 7: SortBy
		strParam += "," + this.report.SortBy + "|SortBy";

		//Parameter 8: SortDirection
		strParam += "," + this.report.SortDirection + "|SortDirection";

		//Parameter 9: SchoolID
		strParam += "," + this.report.SchoolID + "|SchoolID";

		//Parameter 10: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
